import React from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Grid,
} from '@mui/material'
import { StadsprognoseFormData, StadsprognoseConfig } from '../../../types/stadsprognoseTypes'

interface Props {
  formData: StadsprognoseFormData
  onChange: (updates: Partial<StadsprognoseFormData>) => void
  config: StadsprognoseConfig | null
}

const Step3Woningbouwplanning: React.FC<Props> = ({ formData, onChange, config }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Woningbouwplanning</Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        Alle velden zijn verplicht.
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Selecteer een Woningbouwplanning</InputLabel>
            <Select
              value={formData.selected_wbp_code}
              label="Selecteer een Woningbouwplanning"
              onChange={(e) => onChange({ selected_wbp_code: e.target.value })}
            >
              <MenuItem value="">
                <em>(selecteer een code)</em>
              </MenuItem>
              {config?.wbp_codes?.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {`${item.code}: ${item.naam ?? item.code}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Step3Woningbouwplanning
